export const channel = new BroadcastChannel('flowscale-hub-channel');

export const broadcastMessage = (message: any) => {
  channel.postMessage(message);
};
